export default "__VITE_ASSET__BfRn6DF0__"